import { IOverlayParameter, IResult, IHeatParameter } from '@/types/map';

declare let ol: any;
export default class HeatMapPGIS {
  private static instances: Map<string, any>;
  private view!: any;
  private fmap!: any;

  private heatmapLayer!: any;
  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;
  }
  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!HeatMapPGIS.instances) {
      HeatMapPGIS.instances = new Map();
    }
    let instance = HeatMapPGIS.instances.get(id);
    if (!instance) {
      instance = new HeatMapPGIS(view, fmap);
      HeatMapPGIS.instances.set(id, instance);
    }
    return instance;
  }

  private async createHeatMapLayer(source?: any, weight?: any): Promise<any> {
    if (this.heatmapLayer) {
      return this.heatmapLayer;
    }
    const vectorSource = new ol.source.Vector({})
    const heatmapLayer = new ol.layer.Heatmap({
      source: vectorSource
    })

    this.heatmapLayer = heatmapLayer;
    return heatmapLayer;
  }

  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    const points = params.points;
    if (!points.length) {
      return {
        status: 0,
        message: '需要坐标点位数组！'
      }
    }
    const options = params.options;
    const blur = options.blur || 15;
    const radius = options.radius || 8;
    const field = options.field;
    let weight;
    if (field && (typeof field === "string")) {
      weight = function (feature: any) {
        return feature.attributes.field;
      }
    }

    const gradient = options.colors;
    const minZoom = options.minZoom;
    const maxZoom = options.maxZoom;

    const features = [];
    for (let point of points) {
      const geometry = point.geometry;
      const feature = this.getFeature("point", geometry);
      let attributes: any = null;
      attributes = point.fields;
      feature.attributes = attributes;

      features.push(feature);
    }

    //已经存在heatmap layer,删除
    if (this.heatmapLayer) {
      await this.deleteHeatMap();
    }
    const heatmapLayer = new ol.layer.Heatmap({
      source: new ol.source.Vector({
        features: features
      }),
      weight: weight ? weight : 'weight'
    })

    this.heatmapLayer = heatmapLayer;
    this.view.addLayer(heatmapLayer);

    if (blur && typeof blur === "number") {
      heatmapLayer.setBlur(blur);
    }
    if (radius && typeof radius === "number") {
      heatmapLayer.setRadius(radius);
    }
    if (gradient && gradient instanceof Array) {
      heatmapLayer.setGradient(gradient)
    }
    if (maxZoom && typeof maxZoom === "number") {
      heatmapLayer.setMaxZoom(maxZoom);
    }
    if (minZoom && typeof minZoom === "number") {
      heatmapLayer.setMinZoom(minZoom);
    }

    return {
      status: 0,
      message: '成功调用addHeatMap方法！'
    }
  }

  public async addHeatSource(params: IHeatParameter): Promise<IResult> {
    if (!this.heatmapLayer) {
      return {
        status: 0,
        message: '成功调用addHeatSource方法！请先添加一张热力图！'
      }
    }

    const points = params.points;
    const features = [];
    for (let point of points) {
      const geometry = point.geometry;
      const feature = this.getFeature("point", geometry);
      let attributes: any = null;
      attributes = point.fields;
      feature.attributes = attributes;

      features.push(feature);
    }
    const preSource = this.heatmapLayer.getSource();
    const curSource = preSource.addFeatures(features);
    this.heatmapLayer.setSource(curSource);

    return {
      status: 0,
      message: '成功调用addHeatMap方法！修改了已经存在的热力图！'
    }
  }

  public async deleteHeatMap(): Promise<IResult> {
    return {
      status: 0,
      message: 'not complete'
    }
  }

  private getFeature(geoType: any, params: any): any {
    const feature = new ol.Feature();
    const geometry = params;
    if (geoType === "point") {
      const geom = new ol.geom.Point([geometry.x, geometry.y])
      feature.setGeometry(geom);
    } else if (geoType === "polyline") {
      const geom = new ol.geom.LineString(geometry.paths)
      feature.setGeometry(geom);
    } else if (geoType === "polygon") {
      const geom = new ol.geom.Polygon([geometry.rings])
      feature.setGeometry(geom);
    } else {
      console.error('请检查输入的symbol或defaultSymbol是否正确!')
      return false
    }
    return feature;
  }
}